/* eslint-disable array-callback-return */
/* eslint-disable indent */
import React, { Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import Skeleton from "react-loading-skeleton";
import moment from "moment";
import ReactTooltip from "react-tooltip";

import Button from "../../component/button/Button";
import Card from "../../component/card/Card";
import HeaderTag from "../../component/smallComponents/HeaderTag";
import P from "../../component/smallComponents/P";
import Strong from "../../component/smallComponents/Strong";
import { ruleActions, locationActions } from "../../redux/actions";
import CreateRulesModal from "./CreateRulesModal";
import CurrentRulesCard from "./CurrentRulesCard";
import { helperFunction } from "../../constant/helper";
import SelectInput2 from "../../component/input/SelectInput2";
import {
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  renderLocationFunction
} from "../../constant/helper/helper";
import Starter from "../../component/Starter";
// import EditRule from "./EditRule";
// import SpinnerComponent from "../../component/spinner/Spinner";

const inTime = "In Time";
const outTime = "Out Time";

const ShiftTypes = {
  GENERAL_SHIFT: "GENERAL SHIFT",
  FIRST_SHIFT: "FIRST SHIFT",
  NIGHT_SHIFT: "NIGHT SHIFT",
  TWENTY_FOUR_HRS_SHIFT: "24 HRS SHIFT"
};

const initialState = {
  sickLeaves: 0,
  shiftType: "",
  halfDayCeil: 0,
  bufferTime: 15,
  casualLeaves: 0,
  halfDayFloor: 0,
  forLocation: "",
  willExpireOn: "",
  shiftIn: "00:00",
  shiftOut: "00:00",
  needBasedLeaves: 0,
  privilegeLeaves: 0,
  activationDate: ""
};

const Rules = () => {
  const dispatch = useDispatch();
  const loginType = localStorage.loginType;
  const [locationId, setLocationId] = useState("");
  const [values, setValues] = useState(initialState);
  const [allLocations, setAllLocations] = useState([]);
  const [allActiveRules, setAllActiveRules] = useState([]);
  const [allInActiveRules, setAllInActiveRules] = useState([]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value
    });
  };
  // const onEdit = (e) => {
  //   const { name, value } = e.target;
  //   setValues({
  //     ...values,
  //     [name]: value
  //   });
  // };

  const showShiftTypeOptions = Object.values(ShiftTypes).map(
    (type, index) => (
      <option value={type} key={index}>
        {type}
      </option>
    )
  );

  const {
    activeNow,
    ruleError,
    inActiveNow,
    ruleLoading,
    ruleResponse,
    rulesCreateError,
    ruleCreateLoading,
    ruleCreateResponse
  } = useSelector((state) => state.rule);

  const { locationError, locations } = useSelector(
    (state) => state.location
  );
  const { currentUser } = useSelector((state) => state.auth);

  // on get rules
  useEffect(() => {
    if (ruleResponse) {
      helperFunction.toastHelper("success", ruleResponse);
    }
    if (ruleError) {
      helperFunction.toastHelper("error", ruleError);
    }

    if (rulesCreateError) {
      helperFunction.toastHelper("error", rulesCreateError);
    }

    if (locationError) {
      helperFunction.toastHelper("error", locationError);
    }
    if (ruleCreateResponse) {
      helperFunction.toastHelper("success", ruleCreateResponse);
    }
  }, [
    ruleResponse,
    ruleError,
    rulesCreateError,
    ruleCreateResponse,
    locationError
  ]);

  useEffect(() => {
    if (locations !== null) {
      setAllLocations(locations);
    } else {
      setAllLocations([]);
    }
  }, [locations]);

  useEffect(() => {
    // const activeRuleArray = [];
    // const inActiveRuleArray = [];
    // if (activeNow !== null) {
    //   activeNow.map((foundRule) => {
    //     activeRuleArray.push({
    //       _id: foundRule._id,
    //       shiftIn: foundRule.shiftIn,
    //       shiftOut: foundRule.shiftOut,
    //       shiftCode: foundRule.shiftCode,
    //       shiftType: foundRule.shiftType,
    //       locationName: foundRule.locationName,
    //       locationType: foundRule.locationType
    //     });
    //   });

    if (activeNow !== null && inActiveNow !== null) {
      setAllActiveRules(activeNow);
      setAllInActiveRules(inActiveNow);
    } else {
      setAllActiveRules([]);
      setAllInActiveRules([]);
    }
  }, [activeNow, inActiveNow]);

  const commonRulesDispatch = () => {
    dispatch(ruleActions.setRulesLoading(true));
    dispatch(ruleActions.clearRulesErrors());
    dispatch(ruleActions.clearRulesResult());
  };

  useEffect(() => {
    // location
    dispatch(locationActions.clearLocationErrors());
    dispatch(locationActions.clearLocationResult());

    return () => {
      dispatch(ruleActions.setRulesLoading(false));
      dispatch(ruleActions.clearRulesErrors());
      dispatch(ruleActions.clearRulesResult());
      // location
      dispatch(locationActions.clearLocationErrors());
      dispatch(locationActions.clearLocationResult());
    };
  }, []);

  // creating rule
  const onCreateRulesSubmit = (e) => {
    e.preventDefault();
    const date = {
      activationDate: moment(values.activationDate).format(),
      willExpireOn: moment(values.willExpireOn).format()
    };
    // console.log(date);
    const keys = Object.keys(date);
    keys.map((x) => {
      values[x] = date[x];
    });
    // console.log(values);
    const createdBy = currentUser.id;
    dispatch(ruleActions.setRulesCreateLoading(true));
    dispatch(ruleActions.clearRulesErrors());
    dispatch(ruleActions.clearRulesResult());
    dispatch(ruleActions.createRules(values, createdBy, loginType));
  };

  // activate rule
  const onActivateRule = async (e, rule_id) => {
    e.preventDefault();
    const editedById = currentUser.id;
    commonRulesDispatch();
    dispatch(
      ruleActions.activateRule(rule_id, loginType, editedById)
    );
  };

  // skeleton
  const skeletonEffect = () => (
    <div className="col-lg-6">
      <Card isHeader={false}>
        <Skeleton height={150} />
        <Skeleton height={150} />
        <Skeleton height={70} />
      </Card>
    </div>
  );

  const deleteRule = (e, ruleId) => {
    e.preventDefault();
    commonRulesDispatch();
    dispatch(ruleActions.deleteRule(ruleId, loginType, locationId));
  };

  const renderRules = (rulesToShow, type) => {
    if (ruleLoading) {
      return (
        <>
          {skeletonEffect()}
          {skeletonEffect()}
          {skeletonEffect()}
          {skeletonEffect()}
        </>
      );
    } else if (
      typeof rulesToShow !== "undefined" &&
      rulesToShow !== null &&
      rulesToShow.length > 0
    ) {
      return rulesToShow.map((currentRule, parentIndex) => (
        <div className="col-lg-6" key={parentIndex}>
          <CurrentRulesCard
            currentRule={currentRule}
            activateRule={(e) => onActivateRule(e, currentRule._id)}
            deleteRule={(e) => deleteRule(e, currentRule._id)}
          />
          {/* <EditRule
            currentRule={currentRule}
            parentIndex={parentIndex}
          /> */}
        </div>
      ));
    } else if (rulesToShow === null) {
      return (
        <Card>
          <h1 className="title">
            Please select location to see RULES
          </h1>
        </Card>
      );
    } else if (rulesToShow.length === 0) {
      return (
        <Card>
          <h1 className="title">
            No {type} Rules Found, Please Create rules
          </h1>
        </Card>
      );
    }
  };

  const onLocationChange = (e) => {
    const { value } = e.target;
    setLocationId(value);
    commonRulesDispatch();
    dispatch(ruleActions.getAllRulesByLocationId(value, loginType));
  };

  return (
    <Starter
      topBarTitle="Rules"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Rules Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Rules</a>
          </li>
          <li className="breadcrumb-item active">All Rules</li>
        </Fragment>
      }
    >
      <ReactTooltip
        id="locationId"
        place="top"
        effect="solid"
        type="info"
      >
        Select Location to get the rules
      </ReactTooltip>

      <Card>
        <div className="row">
          <div className="col-lg-12">
            <Strong
              title="All inputs are compulsory*"
              className="text-danger float-right"
            />
            <HeaderTag
              type="h4"
              title="Add Rules"
              isClassName={false}
            />
            <P title="Fill the form below to add Add New Rules" />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-3">
            <Button
              type="button"
              data-toggle="modal"
              title="Create New Rules"
              isBackgroundColor={false}
              data-target="#dark-header-modal"
              icon="mdi mdi-plus-circle-outline mr-2"
              className="btn mb-2 text-white btn-dark btn-block"
            />
          </div>
          <div className="col-lg-3">
            <SelectInput2
              data-tip
              isLabeled={true}
              name="locationId"
              value={locationId}
              data-for="locationId"
              label="Select Location"
              onChange={onLocationChange}
              placeholder="Select Location"
              icon="mdi mdi-map-marker-radius"
            >
              {isSuperAdmin(currentUser)
                ? renderLocationFunction(allLocations)
                : renderAccessLocation2(
                    locationRender(currentUser, false)
                  )}
            </SelectInput2>
          </div>
          <CreateRulesModal
            values={values}
            inTimeString={inTime}
            outTimeString={outTime}
            locations={allLocations}
            currentUser={currentUser}
            loading={ruleCreateLoading}
            onChange={handleInputChange}
            onCreateRulesSubmit={onCreateRulesSubmit}
            showShiftTypeOptions={showShiftTypeOptions}
          />
        </div>
      </Card>

      <div className="row">
        <div className="col-lg-6 col-md-12 col-xl-6">
          <HeaderTag
            type="h4"
            title="Currently Active"
            isClassName={false}
            style={{ textAlign: "center" }}
          />
          <div className="row">
            {renderRules(allActiveRules, "Active")}
          </div>
        </div>
        <div className="col-lg-6 col-md-12 col-xl-6">
          <HeaderTag
            type="h4"
            title="In Active"
            isClassName={false}
            style={{ textAlign: "center" }}
          />
          <div className="row">
            {renderRules(allInActiveRules, "In-Active")}
          </div>
        </div>
      </div>
    </Starter>
  );
};

export default Rules;
